package diana.soleil.design.iraniancanadienbazzar.feature.business

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/** Koin bindings for the Business feature. Aggregated by the app composition root (`:shared`). */
val businessModule = module {
    viewModel { (categoryId: String) -> BusinessListViewModel(get(), get(), get(), get(), get(), get(), categoryId) }
    viewModel { (businessId: String) -> BusinessDetailViewModel(get(), get(), get(), get(), get(), get(), get(), get(), get(), businessId) }
    viewModel { SearchViewModel(get(), get(), get(), get(), get(), get(), get()) }
    viewModel { MapViewModel(get(), get()) }
    viewModel { (businessId: String) -> WriteReviewViewModel(get(), get(), get(), businessId) }
    viewModel { (businessId: String) -> ClaimBusinessViewModel(get(), get(), get(), businessId) }
    viewModel { (businessId: String) -> AllReviewsViewModel(get(), get(), businessId) }
    viewModel { (businessId: String) -> AllPhotosViewModel(get(), businessId) }
}
